import { includesIgnoringCase } from '@/utils'

export const getTextFromOptionValue = (
  options: any[],
  defaultValue?: string | number,
) => {
  const option = options.find((opt) => opt.value === defaultValue)
  return option?.children ?? defaultValue
}

export const filterOptions = (inputValue: string, options: any[]) => {
  const optionValues = options.map((opt) => opt.children)

  if (inputValue && !optionValues.includes(inputValue)) {
    return options.filter((opt) =>
      includesIgnoringCase(opt.children, inputValue),
    )
  }

  return options
}
